module.exports = __webpack_public_path__ + "static/research-emphasis-splash-2cbd177918bfdd2b4f94cbb94a1f827d.jpg";